import { render } from "./roomCard.vue?vue&type=template&id=349c4c2a&scoped=true"
import script from "./roomCard.vue?vue&type=script&lang=js"
export * from "./roomCard.vue?vue&type=script&lang=js"

import "./roomCard.vue?vue&type=style&index=0&id=349c4c2a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-349c4c2a"]])

export default __exports__